import cozinha1 from "./assets/images/cozinha1.jpg"; 
import cozinha2 from "./assets/images/cozinha2.jpg";
import cozinha3 from "./assets/images/cozinha3.jpg";
import cozinha4 from "./assets/images/cozinha4.jpg";
import cozinha5 from "./assets/images/cozinha5.jpg";
import cozinha6 from "./assets/images/cozinha6.jpg";
import cozinha7 from "./assets/images/cozinha7.jpg";
import cozinha8 from "./assets/images/cozinha8.jpg";
import cozinha9 from "./assets/images/cozinha9.jpg";
import cozinha10 from "./assets/images/cozinha10.jpg";
import cozinha11 from "./assets/images/cozinha11.jpg";
import cozinha12 from "./assets/images/cozinha12.jpeg";
import cozinha13 from "./assets/images/cozinha13.jpg";
import loja1 from "./assets/images/loja1.jpg";
import loja2 from "./assets/images/loja2.jpg";
import loja3 from "./assets/images/loja3.jpg";
import loja4 from "./assets/images/loja4.jpg";
import sala1 from "./assets/images/sala1.jpg";
import sala2 from "./assets/images/sala2.jpg";
import sala3 from "./assets/images/sala3.jpg";
import sala4 from "./assets/images/sala4.jpg";
import quarto1 from "./assets/images/quarto1.jpg";
import quarto2 from "./assets/images/quarto2.jpg";
import banheiro1 from "./assets/images/banheiro1.jpg";
import banheiro2 from "./assets/images/banheiro2.jpg";
import banheiro3 from "./assets/images/banheiro3.jpg";
import banheiro4 from "./assets/images/banheiro4.jpg";
import banheiro5 from "./assets/images/banheiro5.jpg";
import servico1 from "./assets/images/servico1.jpg";
import servico2 from "./assets/images/servico2.jpg";
import servico3 from "./assets/images/servico3.jpg";

import digital1 from "./assets/images/3d1.jpg";
import digital2 from "./assets/images/3d2.jpg";
import digital3 from "./assets/images/3d3.jpg";
import digital4 from "./assets/images/3d4.jpg";
import digital5 from "./assets/images/3d5.jpg";
import consultoria from "./assets/images/consultor.jpg";
import sustentavel from "./assets/images/sustentavel.jpg";



export const projects = [
  {
    title: "Cozinhas Planejadas",
    subtitle: "Elegância e Funcionalidade em Sua Cozinha",
    description:
      "Transforme sua cozinha em um espaço de sonho com armários sob medida, ilhas modernas e soluções inteligentes de armazenamento.",
      images: [
        cozinha1,cozinha2,cozinha3,cozinha4,cozinha5,cozinha6,cozinha7,cozinha8,cozinha9,cozinha10,cozinha11,cozinha12,cozinha13
      ],
        // Os benefícios que você quer exibir, separados por ponto e vírgula
    products: [
    "Armários sob medida",
    "Ilhas de cozinha",
    "Bancadas e balcões",
    "Isentos de metais pesados.",
    "Armários aéreos",
    "Gaveteiros organizadores",
    "Espaços para encaixe de eletrodomésticos",
  ],
  },
  {
    title: "Lojas / Comércio",
    subtitle: "Estilo e Funcionalidade para o Seu Comércio",
    description:
      "Móveis Sob Medida para Lojas: Elegância e Eficiência. Crie um ambiente acolhedor e funcional com designs que refletem sua marca e otimizam o espaço.",
      images: [
        loja1, loja2, loja3, loja4
      ],
      products: [
        "Vitrines Customizadas para Exposição Impactante",
        "Balcões de Atendimento Sob Medida",
        "Estantes e Prateleiras Comerciais Versáteis",
        "Móveis de Exposição Estilosos para Produtos",
      ],
  },
  {
    title: "Móveis para Sala de Estar",
    subtitle: "Conforto e Beleza para Seu Convívio",
    description:
      "Eleve sua sala de estar com painéis de TV elegantes, racks funcionais e mesas de centro que combinam estilo e utilidade.",
    images: [sala1, sala2, sala3, sala4],
    products: [
      "Painéis de TV", 
      "Racks", 
      "Mesas de centro" , 
      "Nichos para decoração",
    ],
  },
  {
    title: "Dormitório/Closet",
    subtitle: "Personalização e Conforto no Seu Refúgio",
    description:
      "Transforme seu dormitório com closets personalizados e mesas de cabeceira sob medida. Aproveite cada centímetro com móveis funcionais e elegantes, perfeitos para quartos infantis e espaços compactos.",
    images: [quarto1, quarto2],
    products: [
      "Closets Personalizados com Espaços Inteligentes",
      "Armários Sob Medida para Organização Otimizada",
      "Sistemas de Prateleiras Modulares para Closets",
      "Soluções Elegantes de Armazenamento para Vestuário",
    ],
  },
  {
    title: "Banheiros Planejados",
    subtitle: "Modernidade e Praticidade no Seu Banheiro",
    description:
      "Revitalize seu banheiro com armários elegantes, prateleiras de nicho e soluções de armazenamento que combinam com qualquer estilo.",
    images: [banheiro1, banheiro2, banheiro3, banheiro4, banheiro5],
    products: [
      "Armários para pia",
      "Prateleiras e nichos",
      "Armários com espelho",
      "Gabinetes sob medida",
    ],
  },
  {
    title: "Área de Serviço",
    subtitle: "Eficiência e Organização para o Dia a Dia",
    description:
      "Otimize sua área de serviço com armários para produtos de limpeza, bancadas práticas e espaço inteligente para eletrodomésticos.",
    images: [servico1, servico2, servico3],
    products: [
      "Armários para produtos de limpeza",
      "Bancadas para passar roupa",
      "Espaço para máquinas de lavar e secar",
    ],
  },
];


export const services = [
  {
    name: "Consultoria Personalizada",
    image: [consultoria],
    description: "Transforme sua visão em realidade com nossa Consultoria Personalizada em móveis planejados. Nossa equipe de especialistas trabalha lado a lado com você para criar ambientes que refletem seu estilo e atendem às suas necessidades. Cada detalhe é pensado para garantir que o resultado final seja não apenas funcional, mas também um reflexo do seu gosto pessoal. Torne seu espaço único com a nossa consultoria especializada.",
  },
  {
    name: "Projetos 3D e Visualização",
    image: [digital1, digital2, digital3, digital4, digital5],
    description: "Transforme seus sonhos em realidade com nossos Projetos 3D e Visualização. Mergulhe em uma jornada personalizada, onde a tecnologia avançada traz à vida cada nuance do seu espaço ideal. Sinta a textura, admire o layout e explore todos os detalhes antes mesmo de começar. Nossas representações 3D não são apenas precisas, são uma porta para sua imaginação, garantindo que o resultado final seja não apenas o que você esperava, mas um verdadeiro reflexo do seu estilo e personalidade. Venha conosco, e juntos, criaremos o espaço dos seus sonhos.",
  },
  {
    name: "Sustentabilidade",
    image: [sustentavel],
    description: "Comprometidos com o futuro, nossos móveis planejados são sinônimo de Sustentabilidade. Escolhemos materiais eco-friendly e práticas sustentáveis para minimizar o impacto ambiental sem comprometer a qualidade e o design. Cada peça é uma combinação de inovação, responsabilidade ecológica e estilo. Com nossos móveis, você contribui para um mundo mais verde enquanto desfruta de design e funcionalidade excepcionais.",
  },
];